"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Facebook_1 = tslib_1.__importDefault(require("./subtypes/Facebook"));
var facebookpage_1 = tslib_1.__importDefault(require("./subtypes/facebookpage"));
var Instagram_1 = tslib_1.__importDefault(require("./subtypes/Instagram"));
var Twitter_1 = tslib_1.__importDefault(require("./subtypes/Twitter"));
var Social = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty;
    switch (data.subtype) {
        case 'facebookpage':
            return (React.createElement(facebookpage_1["default"], { config: (data.config || {}) }));
        case 'facebook':
            return (React.createElement(Facebook_1["default"], { config: (data.config || {}), renderEmpty: renderEmpty }));
        case 'twitter':
            return (React.createElement(Twitter_1["default"], { config: (data.config || {}), renderEmpty: renderEmpty }));
        case 'instagram':
            return (React.createElement(Instagram_1["default"], { config: (data.config || {}), renderEmpty: renderEmpty }));
        default:
            return renderEmpty ? renderEmpty('social') : null;
    }
};
exports["default"] = Social;
